export class HTTPStatusCode {
	// Ok
	static 200: number = 200;
	
	// Bad Request
	static 400: number = 400;
	
	// Unauthorize
	static 401: number = 401;
	
	// Forbidden
	static 403: number = 403;
	
	// Not Found
	static 404: number = 404;
	
	// Not Acceptable
	static 406: number = 406;
	
	// Internal Server Error
	static 500: number = 500
};
